import {formatNumberForDisplay} from '../../common/number.mjs';

export const transformCategoryItems = (items) => {
	return items.map((item) => {
		const label = currentFilterValuesToLabel[item.label];
    // console.log("[transformCategoryItems][item]:", item)
    // console.log("[transformCategoryItems]]label]:", label)
		return {...item, label};
	});
};

export const transformSubwooferSizes = (items) => {
	items = items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

	return items;
}

export const transformGauges = (items) => {
	items = items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

	items = items.map((item) => {
		const numberGauge = Number(item.label)
		const label = formatNumberForDisplay(numberGauge) + '-Gauge';
		return {...item, label};
	})

	return items;
}

export const transformCapacity = (items) => {
	items = items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

	items = items.map((item) => {
		const numberCapacity = Number(item.label)
		const label = formatNumberForDisplay(numberCapacity) + ' Amp Hours';
		return {...item, label};
	})

	return items;
}

export const transformWatts = (items) => {
	items = items.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

	items = items.map((item) => {
		const numberWatts = Number(item.label)
		const label = formatNumberForDisplay(numberWatts) + ' Watts';
		return {...item, label};
	})

	return items;
}

export const transformAmpBridgeable = (items) => {
	items.sort((a, b) => {
		if (a.value === 'Yes') return -1;
		if (b.value === 'Yes') return 1;
		return a.value.localeCompare(b.value);
	});

	return items;
}

export const updateCurrentRefinedItemAttributeLabels = (items) => {
	return items.map((item) => {
		const label = attributeValueToLabel[item.label] || capitalizeWords(item.label);

		const refinements = item.refinements.map((refinement) => {
			let label = currentFilterValuesToLabel[refinement.value] || capitalizeWords(refinement.value);

			if(item.label === 'specs.watts') {
				label = formatNumberForDisplay(Number(refinement.value));
			}

			return {...refinement, label};
		});

		return {...item, label, refinements};
	});
}

export const capitalizeWords = (string) => {
	if (!string) {
		return null;
	}
	string = string.toLowerCase().trim();
	return string?.split(/\s|_/)?.map((x) => x?.split('-')?.map((y) => y?.[0]?.toUpperCase() + y?.slice(1))?.join('-'))?.join(" ");
}

const currentFilterValuesToLabel = {
	'amplifier-wiring-kits': 'Amplifier Wiring Kits',
	amplifiers: 'Amplifiers',
	'bass-knob-remote-controls': 'Bass Knob Remote Controls',
	batteries: 'Batteries',
	'complete-bass-package': 'Complete Bass Package',
	'electronics-equalizers-and-crossovers': 'Equalizers and Crossovers',
	'empty-subwoofer-enclosures': 'Empty Enclosures',
	'frequency-filters': 'Frequency Filters',
	fuses: 'Fuses',
	'loaded-subwoofer-enclosures': 'Loaded Enclosures',
	'miscellaneous-accessories': 'Misc Accessories',
	'power-distribution-blocks': 'Distribution Blocks',
	'rca-interconnects': 'RCA Connectors',
	'speaker-wire': 'Speaker Wire',
	speakers: 'Speakers',
	subwoofers: 'Subwoofers',
	'A/B': 'A/B',
	'A/B & D': 'A/B & D',
	'1-Channel': '1-Channel',
	'4-Channel': '4-Channel',
	'5-Channel': '5-Channel',
};

const attributeValueToLabel = {
	category: 'Category',
	'specs.size': 'Size',
	'specs.watts': 'Amp Watts',
	'specs.bridgeable': 'Bridgeable',
	'specs.class': 'Amp Class',
	'specs.channels': 'Amp Channels',
	'specs.subwooferCount': 'Number of Subwoofers',
	'specs.enclosureType': 'Enclosure Type',
	'specs.finishType': 'Finish Type',
	'specs.gauge': 'Wiring Gauge',
	'specs.voiceCoilImpedance': 'Impedance',
	'specs.peak': 'Watts',
	'specs.type': 'Type',
	'specs.vehicleSpecific': 'Vehicle Specific',
}

export const categoryValuesToLabel = {
	"empty-subwoofer-enclosures": "Empty Subwoofer Enclosures",
	"complete-bass-package": "Complete Bass Package",
	"subwoofers": "Subwoofers",
	"loaded-subwoofer-enclosures": "Loaded Subwoofer Enclosures",
	"speakers": "Speakers",
	"bass-knob-remote-controls": "Bass Knob Remote Controls",
	"amplifiers": "Amplifiers",
	"batteries": "Batteries",
	"power-distribution-blocks": "Power Distribution Blocks",
	"miscellaneous-accessories": "Miscellaneous Accessories",
	"tweeter-diaphragms": "Tweeter Diaphragms",
	"fuses": "Fuses",
	"frequency-filters": "Frequency Filters",
	"sound-deadening-kits": "Sound Deadening Kits",
	"electronics-equalizers-and-crossovers": "Electronics, Equalizers and Crossovers",
	"amplifier-wiring-kits": "Amplifier Wiring Kits",
	"rca-interconnects": "RCA Interconnects",
	"marine-subwoofers": "Marine Subwoofers",
	"speaker-wire": "Speaker Wire"
}
